export default {
  API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
  OLD_API_BASE_URL: process.env.NEXT_PUBLIC_OLD_API_BASE_URL,
  CDN_SERVER_URL: process.env.NEXT_PUBLIC_CDN_SERVER_URL,
  CDN_SERVER_BASE_URL: process.env.NEXT_PUBLIC_CDN_SERVER_BASE_URL,
  APP_BASE_URL: process.env.NEXT_PUBLIC_APP_BASE_URL,
  DECRYPTION_KEY: process.env.NEXT_PUBLIC_DECRIYPTION_KEY,
};

export const CURRENCY_SYMBOL = '₹';
